/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { createContext, useContext } from "react";

export interface IFieldListItemContext {
	id: string;
	index: number;
	disabled: boolean;
	onExpandChange: React.MouseEventHandler;
	expanded: boolean;
	draggable: boolean;
}

export const FieldListItemContext = createContext<IFieldListItemContext>(null);

export function useFieldListItemContext(): IFieldListItemContext {
	return useContext(FieldListItemContext);
}
